<template>
    <div id='cauui-editar'>
        <form v-on:submit.prevent= 'guardarInmueble'>
            <div class="column is-half is-offset-one-quarter ">
                <br>
                <h2 align="center"><b>Modificar</b></h2>
                <br>
                <a @click="$router.go(-1)" center >Regresar</a>
                <br><br>                

                <div class='field'>
                  <label class='label'>Tipo de inmueble</label>
                  <div class='control'>
                    <select class='select' type='text' v-model='inmuebles21.tipo47' maxlength='15' required >
                        <option value="Bodega">Bodega</option>
                        <option value="Casa">Casa</option>
                        <option value="Cuarto">Cuarto</option>
                        <option value="Departamento">Departamento</option>
                        <option value="Local-comercial">Local-comercial</option>
                        <option value="Oficina">Oficina</option>
                        <option value="Terreno">Terreno</option>
                    </select>
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Venta o Renta o Traspaso</label>
                  <div class='control'>
                    <select class='select' type='text' v-model='inmuebles21.ventaRenta' maxlength='8' required >
                        <option value="Renta">Renta</option>
                        <option value="Traspaso">Traspaso</option>
                        <option value="Venta">Venta</option>
                    </select>
                  </div>
                </div>                
                <div class='field'>
                  <label class='label'>Titulo o encabezado o descripcion corta (Opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' placeholder='Ej. Casa de campo' v-model='inmuebles21.nombre47' maxlength='150' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Describe el inmueble</label>
                  <div class='control'>
                    <textarea class='textarea' type='text' v-model='inmuebles21.descripcion47' maxlength="400" required></textarea> 
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Familia o Linea o Condominio o Grupo (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' placeholder='Ej. Torre Blanca' v-model='inmuebles21.familia47' maxlength='30' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Nombre del contacto (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text'  v-model='inmuebles21.contactoNom47' maxlength='150' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Mail para contacto (opcional)</label>
                  <div class='control'>
                    <input class='input' type='email'  v-model='inmuebles21.mailContacto47' maxlength='300' >
                  </div>
                </div>    
                <div class='field'>
                  <label class='label'>Whatsapp para contacto (opcional)</label>
                  <div class='control'>
                    <input class='input' type='number' v-model='inmuebles21.whatsappContacto' maxlength='15' >
                  </div>
                </div> 
                <div class='field'>
                  <label class='label'>Celular para contacto</label>
                  <div class='control'>
                    <input class='input' type='number' v-model='inmuebles21.cel' maxlength='15' required>
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Telefono para contacto (opcional)</label>
                  <div class='control'>
                    <input class='input' type='telephone' v-model='inmuebles21.cel2' maxlength='15' >
                  </div>
                </div>                 
                <div class='field'>
                  <label class='label'>Calle y numero del inmueble</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.direccion47' maxlength='200' required>
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Colonia del inmueble</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.colonia' maxlength='50' required>
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Ciudad del inmueble</label>
                  <div class='control'>
                    <select class='select' type='text' v-model='inmuebles21.mpio' required >
                                <option value=''>Todas</option>
                                <option value='Acapulco'>Acapulco</option>
                                <option value='Aguascalientes'>Aguascalientes</option>
                                <option value='Apodaca'>Apodaca</option>
                                <option value='Buenavista'>Buenavista</option>
                                <option value='Campeche'>Campeche</option>
                                <option value='Cancún'>Cancún</option>
                                <option value='Celaya'>Celaya</option>
                                <option value='Chalco'>Chalco</option>
                                <option value='Chetumal'>Chetumal</option>
                                <option value='Chicoloapan'>Chicoloapan</option>
                                <option value='Chihuahua'>Chihuahua</option>
                                <option value='Chilpancingo'>Chilpancingo</option>
                                <option value='Chimalhuacán'>Chimalhuacán</option>
                                <option value='Ciudad Acuña'>Ciudad Acuña</option>
                                <option value='Ciudad de México'>Ciudad de México</option>
                                <option value='Ciudad del Carmen'>Ciudad del Carmen</option>
                                <option value='Ciudad López Mateos'>Ciudad López Mateos</option>
                                <option value='Ciudad Madero'>Ciudad Madero</option>
                                <option value='Ciudad Obregón'>Ciudad Obregón</option>
                                <option value='Ciudad Valles'>Ciudad Valles</option>
                                <option value='Ciudad Victoria'>Ciudad Victoria</option>
                                <option value='Coatzacoalcos'>Coatzacoalcos</option>
                                <option value='Colima'>Colima</option>
                                <option value='Córdoba'>Córdoba</option>
                                <option value='Corregidora'>Corregidora</option>
                                <option value='Cuauhtémoc'>Cuauhtémoc</option>
                                <option value='Cuautitlán'>Cuautitlán</option>
                                <option value='Cuautitlán Izcalli'>Cuautitlán Izcalli</option>
                                <option value='Cuautla'>Cuautla</option>
                                <option value='Cuernavaca'>Cuernavaca</option>
                                <option value='Culiacán'>Culiacán</option>
                                <option value='Delicias'>Delicias</option>
                                <option value='Durango'>Durango</option>
                                <option value='Ecatepec'>Ecatepec</option>
                                <option value='El Marquez'>El Marques</option>
                                <option value='Ensenada'>Ensenada</option>
                                <option value='Fresnillo'>Fresnillo</option>
                                <option value='General Escobedo'>General Escobedo</option>
                                <option value='Gómez Palacio'>Gómez Palacio</option>
                                <option value='Guadalajara'>Guadalajara</option>
                                <option value='Guadalupe'>Guadalupe</option>
                                <option value='Guadalupe'>Guadalupe</option>
                                <option value='Guaymas'>Guaymas</option>
                                <option value='Hermosillo'>Hermosillo</option>
                                <option value='Hidalgo del Parral'>Hidalgo del Parral</option>
                                <option value='Iguala'>Iguala</option>
                                <option value='Irapuato'>Irapuato</option>
                                <option value='Ixtapaluca'>Ixtapaluca</option>
                                <option value='Jiutepec'>Jiutepec</option>
                                <option value='Juárez'>Juárez</option>
                                <option value='Juárez'>Juárez</option>
                                <option value='La Paz'>La Paz</option>
                                <option value='Lagos de Moreno'>Lagos de Moreno</option>
                                <option value='León'>León</option>
                                <option value='Los Cabos'>Los Cabos</option>
                                <option value='Los Mochis'>Los Mochis</option>
                                <option value='Manzanillo'>Manzanillo</option>
                                <option value='Matamoros'>Matamoros</option>
                                <option value='Mazatlán'>Mazatlán</option>
                                <option value='Mérida'>Mérida</option>
                                <option value='Mexicali'>Mexicali</option>
                                <option value='Minatitlán'>Minatitlán</option>
                                <option value='Miramar'>Miramar</option>
                                <option value='Monclova'>Monclova</option>
                                <option value='Monterrey'>Monterrey</option>
                                <option value='Morelia'>Morelia</option>
                                <option value='Naucalpan'>Naucalpan</option>
                                <option value='Naucalpan de Juárez'>Naucalpan de Juárez</option>
                                <option value='Navojoa'>Navojoa</option>
                                <option value='Nezahualcóyotl'>Nezahualcóyotl</option>
                                <option value='Nogales'>Nogales</option>
                                <option value='Nuevo Laredo'>Nuevo Laredo</option>
                                <option value='Oaxaca de Juárez'>Oaxaca de Juárez</option>
                                <option value='Ojo de Agua'>Ojo de Agua</option>
                                <option value='Orizaba'>Orizaba</option>
                                <option value='Pachuca'>Pachuca</option>
                                <option value='Piedras Negras'>Piedras Negras</option>
                                <option value='Playa del Carmen'>Playa del Carmen</option>
                                <option value='Poza Rica de Hidalgo'>Poza Rica de Hidalgo</option>
                                <option value='Puebla'>Puebla</option>
                                <option value='Puerto Vallarta'>Puerto Vallarta</option>
                                <option value='Querétaro'>Querétaro</option>
                                <option value='Reynosa'>Reynosa</option>
                                <option value='Salamanca'>Salamanca</option>
                                <option value='Saltillo'>Saltillo</option>
                                <option value='San Cristóbal de las Casas'>San Cristóbal de las Casas</option>
                                <option value='San Francisco Coacalco'>San Francisco Coacalco</option>
                                <option value='San Juan Bautista Tuxtepec'>San Juan Bautista Tuxtepec</option>
                                <option value='San Juan del Río'>San Juan del Río</option>
                                <option value='San Juan del Los Lagos'>San Juan del Los Lagos</option>
                                <option value='San Luis Potosí'>San Luis Potosí</option>
                                <option value='San Luis Río Colorado'>San Luis Río Colorado</option>
                                <option value='San Miguel de Allende'>San Miguel de Allende</option>
                                <option value='San Nicolás de los Garza'>San Nicolás de los Garza</option>
                                <option value='San Pablo de las Salinas'>San Pablo de las Salinas</option>
                                <option value='San Pedro Garza García'>San Pedro Garza García</option>
                                <option value='Santa Catarina'>Santa Catarina</option>
                                <option value='Soledad de Graciano Sánchez'>Soledad de Graciano Sánchez</option>
                                <option value='Tampico'>Tampico</option>
                                <option value='Tapachula'>Tapachula</option>
                                <option value='Taxco'>Taxco</option>
                                <option value='Tehuacán'>Tehuacán</option>
                                <option value='Tepexpan'>Tepexpan</option>
                                <option value='Tepic'>Tepic</option>
                                <option value='Texcoco de Mora'>Texcoco de Mora</option>
                                <option value='Tijuana'>Tijuana</option>
                                <option value='Tlalnepantla'>Tlalnepantla</option>
                                <option value='Tlaquepaque'>Tlaquepaque</option>
                                <option value='Toluca'>Toluca</option>
                                <option value='Tonalá'>Tonalá</option>
                                <option value='Torreón'>Torreón</option>
                                <option value='Tulancingo de Bravo'>Tulancingo de Bravo</option>
                                <option value='Tuxtla'>Tuxtla</option>
                                <option value='Uruapan'>Uruapan</option>
                                <option value='Veracruz'>Veracruz</option>
                                <option value='Villa de Álvarez'>Villa de Álvarez</option>
                                <option value='Villa Nicolás Romero'>Villa Nicolás Romero</option>
                                <option value='Villahermosa'>Villahermosa</option>
                                <option value='Xalapa Enriquez'>Xalapa Enriquez</option>
                                <option value='Xico'>Xico</option>
                                <option value='Zacatecas'>Zacatecas</option>
                                <option value='Zamora'>Zamora</option>
                                <option value='Zapopan'>Zapopan</option>
                     </select>
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Delegacion</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.deleg' maxlength='50' >
                  </div>
                </div>                
                <div class='field'>
                  <label class='label'>Estado</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.edo' maxlength='50' required >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Codigo Postal (opcional)</label>
                  <div class='control'>
                    <input class='input' type='number' v-model='inmuebles21.codigoPostal' maxlength='5' >
                  </div>
                </div>                
                <div class='field'>
                  <label class='label'>Pais</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.pais' maxlength='50' value="Mexico" required >
                  </div>
                </div>

                <div class='field'>
                  <label class='label'>Metros cuadrados de la construcción</label>
                  <div class='control'>
                    <input class='input' type='number' v-model='inmuebles21.m2C' maxlength='7' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Metros cuadrados del terreno</label>
                  <div class='control'>
                    <input class='input' type='number' v-model='inmuebles21.m2T' maxlength='7' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Importe</label>
                  <div class='control'>
                    <input class='input' type='number' v-model='inmuebles21.importe1' maxlength='15' required >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Moneda</label>
                  <div class='control'>
                    <input class='input' type='text'  v-model='inmuebles21.moneda1' maxlength='3' required>
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Requisitos (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text'  v-model='inmuebles21.requisitos' maxlength='200' >
                  </div>
                </div>

                <div class='field'>
                  <label class='label'>Web del inmueble (opcional)</label>
                  <div class='control'>
                    <input class='input' type='web'  v-model='inmuebles21.web47' maxlength='200' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Facebook del inmueble (opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.facebook47' maxlength='200' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Ubicacion en Maps o Google Earth (Ingresa a Maps y compartela)(opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' v-model='inmuebles21.ubicacion' placeholder="Ej. https://maps.app.goo.gl/aecdZ7BDmhKgXTC21" maxlength='200' >
                  </div>
                </div>
                <div class='field'>
                  <label class='label'>Codigo Interno (Su identificador del inmueble)(opcional)</label>
                  <div class='control'>
                    <input class='input' type='text' placeholder='Ej. LOTE201' v-model='inmuebles21.codigoInterno' maxlength='30' >
                  </div>
                </div> 
                <br>
                    <div class="notification">
                        <i class="fas fa-camera"></i>
                        Recuerde que buenas fotos son muy importantes para rentar o vender su inmueble<br>
                        <b>rentas-ventas.com</b> le dice como <a href="https://www.caballerofotografia.com/home-staging-fotografia-interiores/">aqui</a>
                    </div>
                    <div class="container">
                        <div class="large-12 medium-12 small-12 cell">                        
                            <p v-if="inmuebles21.foto1 !=''">
                            <figure class="image is-128x128">
                                <img v-bind:src="'https://www.rentas-ventas.com/fotosrentasventas/' + inmuebles21.foto1" alt=" "  id ="lafoto1">
                            </figure>
                            </p>
                            <label for="archi"><strong>Buscar imagen 1</strong></label>
                            <input class = "input" type="file" name="archi" id="miArchivo1" ref="fot1" v-on:change="archivoAsubir('fot1')" >
                        </div>                
                    </div>
                    <br><br>

                    <div class="container">
                        <div class="large-12 medium-12 small-12 cell">
                            <p v-if="inmuebles21.foto2 !=''">
                                <figure class="image is-128x128">
                                    <img v-bind:src="'https://www.rentas-ventas.com/fotosrentasventas/' + inmuebles21.foto2" alt=" " id ="lafoto2">
                                </figure>
                            </p>
                            <label for="archi1"><strong>Buscar imagen 2</strong></label>
                            <input class = "input" type="file" name="archi1" id="miArchivo2" ref="fot2" v-on:change="archivoAsubir('fot2')" >
                        </div>                
                    </div>
                    <br><br>

                    <div class="container">
                        <div class="large-12 medium-12 small-12 cell">
                            <p v-if="inmuebles21.logo47 !=''">
                                <figure class="image is-128x128">
                                    <img v-bind:src="'https://www.rentas-ventas.com/fotosrentasventas/' + inmuebles21.logo47" alt=" " id ="logo">
                                </figure>
                            </p>
                            <label for="archi2"><strong>Buscar imagen del logo</strong></label>                        
                            <input class = "input" type="file" name="archi2" id="miArchivoLogo" ref="logo" v-on:change="archivoAsubir('logo')" >
                            <br><br>
                        </div>                
                    </div>

                    <div class='field'>
                      <label class='label'>Liga a video de youtube del inmueble (opcional)</label>
                      <div class='control'>
                        <input class='input' type='text' v-model='inmuebles21.videoYou' v-on:change="verId(inmuebles21.videoYou)">
                      </div>
                      <br><br>

                        <button type="button" v-on:click="verId(inmuebles21.videoYou)" >Ver el video</button>
                            <div >
                                <iframe width="320" height="180" v-bind:src="'//www.youtube.com/embed/' + cualVideo +'?rel=0&showinfo=0&controls=1&autoplay=1&start=120' " frameborder="0" allowfullscreen>
                                </iframe>
                            </div>
                    </div>

                <div class='field'>
                  <label class='label'>Visibilidad</label>
                  <div class='control'>
                    <select class='select' type='text'  v-model='inmuebles21.status47' required>
                        <option value="Visible">Visible</option>
                        <option value="No-visible">No-visible</option>
                        <option value="Baja">Baja</option>
                    </select>
                  </div>
                </div>                    

            </div>
            <br>
            <div align="center">
                <button class="button is-primary" type="submit" name="modificaCausa">Modificar</button>
            </div>

        </form>
        <br><br>

    </div>
</template>

<script>
    import axios from 'axios';
    export default{
            name:'editar-Causa',
            mounted(){
                this.buscarInmueble();
                this.numDeCausa1 = this.$route.params.numDeCausa;
                this.mailAutorizado = this.$route.params.mailAutorizado;
                if(this.mailAutorizado == null || this.mailAutorizado == '') this.$router.push('/');
                this.cualVideo = this.inmuebles21.videoYou;
            },
            data(){
                return {
                    id: null,
                    inmuebles21:{
                        folio47:"",
                        usuario47:"",
                        micrositio:"",
                        codigoInterno:"",
                        nombre47:"",
                        familia47:"",
                        contactoNom47:"",
                        direccion47:"",
                        mailContacto47:"",
                        whatsappContacto:"",
                        descripcion47:"",
                        cel:"",
                        cel2:"",
                        web47:"",
                        facebook47:"",
                        qr47:"",
                        tipo47:"",
                        foto1:"",
                        foto2:"",
                        videoYou:"",
                        logo47:"",
                        colonia:"",
                        mpio:"",
                        edo:"",
                        pais:"",
                        deleg:"",
                        ventaRenta:"",
                        m2C:"",
                        m2T:"",
                        importe1:"",
                        moneda1:"",
                        um1:"",
                        importe2:"",
                        codigoPostal:"",
                        um2:"",
                        requisitos:"",
                        ubicacion:"",
                        status47:""
                    },
                    mailAutorizado: '',
                    logoLeido:"",
                    foto1Leido:"",
                    foto2Leido:"",
                    logo_2:"",
                    foto2_2:"",
                    foto1_2:"",
                    cualVideo: ''
                };
            },
            methods:{
                buscarInmueble(){
                var inm= ''; 
                var inmuebles212= '';

                this.id = this.$route.params.id;
                axios.get('https://www.rentas-ventas.com/leeUnInmueble.php?inm48='+this.id)
                     .then((respue) => {
                        inm = respue.data;
                        
                        var x;
                        for (x in inm) {
                            inmuebles212 = inm[x];
                        }

                        this.inmuebles21.usuario47 = inmuebles212.usuario47;
                        this.inmuebles21.micrositio = inmuebles212.micrositio;
                        this.inmuebles21.codigoInterno = inmuebles212.codigoInterno;
                        this.inmuebles21.nombre47 = inmuebles212.nombre47;
                        this.inmuebles21.familia47 = inmuebles212.familia47;
                        this.inmuebles21.contactoNom47 = inmuebles212.contactoNom47;
                        this.inmuebles21.direccion47 = inmuebles212.direccion47;
                        this.inmuebles21.mailContacto47 = inmuebles212.mailContacto47;
                        this.inmuebles21.whatsappContacto = inmuebles212.whatsappContacto;
                        this.inmuebles21.descripcion47 = inmuebles212.descripcion47;
                        this.inmuebles21.cel = inmuebles212.cel;
                        this.inmuebles21.cel2 = inmuebles212.cel2;
                        this.inmuebles21.web47 = inmuebles212.web47;
                        this.inmuebles21.facebook47 = inmuebles212.facebook47;
                        this.inmuebles21.qr47 = inmuebles212.qr47;
                        this.inmuebles21.tipo47 = inmuebles212.tipo47;

                        this.foto1Leido = inmuebles212.foto1;
                        this.foto2Leido = inmuebles212.foto2;
                        this.logoLeido = inmuebles212.logo47;

                        this.inmuebles21.foto1 = inmuebles212.foto1;
                        this.inmuebles21.foto2 = inmuebles212.foto2;
                        this.inmuebles21.logo47 = inmuebles212.logo47;

                        this.inmuebles21.videoYou = inmuebles212.videoYou;
                        this.inmuebles21.colonia = inmuebles212.colonia;
                        this.inmuebles21.mpio = inmuebles212.mpio;
                        this.inmuebles21.edo = inmuebles212.edo;
                        this.inmuebles21.pais = inmuebles212.pais;
                        this.inmuebles21.deleg = inmuebles212.deleg;
                        this.inmuebles21.ventaRenta = inmuebles212.ventaRenta;
                        this.inmuebles21.m2C = inmuebles212.m2C;
                        this.inmuebles21.m2T = inmuebles212.m2T;
                        this.inmuebles21.importe1 = inmuebles212.importe1;
                        this.inmuebles21.moneda1 = inmuebles212.moneda1;
                        this.inmuebles21.um1 = inmuebles212.um1;
                        this.inmuebles21.importe2 = inmuebles212.importe2;
                        this.inmuebles21.codigoPostal = inmuebles212.codigoPostal;
                        this.inmuebles21.um2 = inmuebles212.um2;
                        this.inmuebles21.ubicacion = inmuebles212.ubicacion;
                        this.inmuebles21.requisitos = inmuebles212.requisitos;
                        this.inmuebles21.status47 = inmuebles212.status47;

                     });
                },
                guardarInmueble(){
                    var inmuebles213= this.inmuebles21;
                    var router= this.$router;

                    // formatea el nombre del micrositio
                    var micro = inmuebles213.micrositio.replace(/\s+/g, ''); // Remplaza TODOS los espacios
                    var micrositio1 = micro.toUpperCase(); 

                    // ve si los nombres de las fotos existen

                    if(inmuebles213.logo47.name == null) {
                        this.logo_2 = this.logoLeido;
                    } else {
                        this.logo_2 = inmuebles213.logo47.name;
                    }

                    if(inmuebles213.foto1.name == null) {
                        this.foto1_2 = this.foto1Leido;
                    } else {
                        this.foto1_2 = inmuebles213.foto1.name;
                    }

                    if(inmuebles213.foto2.name == null) {
                        this.foto2_2 = this.foto2Leido;
                    } else {
                        this.foto2_2 = inmuebles213.foto2.name;
                    }


                    if(this.logo_2 == "undefined"){
                        this.logo_2 = ""; 
                    } 
                    if(this.foto1_2 == "undefined") {
                        this.foto1_2 = "";
                    }
                    if(this.logo_2 == "undefined"){
                        this.logo_2 = "";  
                    } 



                    var elVideo = this.verId(inmuebles213.videoYou)

                    axios.post('https://www.rentas-ventas.com/modificaInmueble.php?cual47=' + this.id 
                        + '&usuario47='+this.inmuebles21.usuario47
                        + '&micrositio='+ micrositio1
                        + '&codigoInterno='+this.inmuebles21.codigoInterno
                        + '&nombre47='+this.inmuebles21.nombre47
                        + '&familia47='+this.inmuebles21.familia47
                        + '&contactoNom47='+this.inmuebles21.contactoNom47
                        + '&direccion47='+this.inmuebles21.direccion47
                        + '&mailContacto47='+this.inmuebles21.mailContacto47
                        + '&whatsappContacto='+this.inmuebles21.whatsappContacto
                        + '&descripcion47='+this.inmuebles21.descripcion47
                        + '&cel='+this.inmuebles21.cel
                        + '&cel2='+this.inmuebles21.cel2
                        + '&web47='+this.inmuebles21.web47
                        + '&facebook47='+this.inmuebles21.facebook47
                        + '&qr47='+this.inmuebles21.qr47
                        + '&tipo47='+this.inmuebles21.tipo47
                        + '&foto1='+this.foto1_2
                        + '&foto2='+this.foto2_2
                        + '&logo47='+this.logo_2
                        + '&videoYou='+this.inmuebles21.videoYou
                        + '&colonia='+this.inmuebles21.colonia
                        + '&mpio='+this.inmuebles21.mpio
                        + '&edo='+this.inmuebles21.edo
                        + '&pais='+this.inmuebles21.pais
                        + '&deleg='+this.inmuebles21.deleg
                        + '&ventaRenta='+this.inmuebles21.ventaRenta
                        + '&m2C='+this.inmuebles21.m2C
                        + '&m2T='+this.inmuebles21.m2T
                        + '&importe1='+this.inmuebles21.importe1
                        + '&moneda1='+this.inmuebles21.moneda1
                        + '&um1='+this.inmuebles21.um1
                        + '&importe2='+this.inmuebles21.importe2
                        + '&codigoPostal='+this.inmuebles21.codigoPostal
                        + '&um2='+this.inmuebles21.um2
                        + '&req='+this.inmuebles21.requisitos
                        + '&ubi='+this.inmuebles21.ubicacion
                        + '&status47='+this.inmuebles21.status47
                         )
                    .then((respue) => {
                        router.go(-1);
                    })
                    .catch((error) =>{
                        console.log(error);
                    });

                    this.subeFotos();

                },
                verId(liga){                    
                    var indice = liga.indexOf("?v=");
                    if(indice == -1) {
                        this.cualVideo = liga;
                    } else {
                        this.cualVideo = liga.substring(indice+3);
                    }
                    return this.cualVideo;

                },
                archivoAsubir(deQuien){
                    // obtiene el archivo seleccionado en el input llamado cualArchivoEs

                        if(deQuien == 'fot1' ){
                            this.inmuebles21.foto1 = this.$refs.fot1.files[0];
                        }
                        if(deQuien == 'fot2' ){
                            this.inmuebles21.foto2 = this.$refs.fot2.files[0];
                        }
                        if(deQuien == 'logo' ){
                            this.inmuebles21.logo47 = this.$refs.logo.files[0];
                        }                   

                },
                subeFotos(){

                    // Se debe llamar igual el id del input y asi tambien 
                    // al recibirlo en subeArchivos.php el primero en el arreglo
                    // de $_FILES se debe llamar tambien igual y en el
                    // move_uploaded_file del .php, en este 
                    // caso miArchivoRentasVentas en los 4 lugares

                    // toma el nombre del archivo
                    let formData = new FormData();

                    if(this.inmuebles21.logo47.name != this.logoLeido && this.inmuebles21.logo47.name != null){

                        formData.append("miArchivoRentasVentas", this.inmuebles21.logo47);

                        //Make the request to the POST /single-file URL                     
                        axios.post( 'https://www.rentas-ventas.com/subeArchivo.php',
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'                   
                                }
                            }
                            ).then(function(){
                                alert('LOGO SUBIDO !!');
                            })
                            .catch(function(){
                                alert('FALLO SUBIR LOGO !!');
                            });
 
                    }
                    
                    if(this.inmuebles21.foto1.name != this.foto1Leido && this.inmuebles21.foto1.name  != null){

                        let formData1 = new FormData();
                        formData1.append("miArchivoRentasVentas", this.inmuebles21.foto1);
                        //Make the request to the POST /single-file URL                     
                        axios.post( 'https://www.rentas-ventas.com/subeArchivo.php',
                            formData1,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'                   
                                }
                            }
                            ).then(function(){
                                alert('SUBIDA foto 1 !!');
                            })
                            .catch(function(){
                                alert('FALLO al subir foto 1 !!');
                            });  

                    }
                    
                    if(this.inmuebles21.foto2.name != this.foto2Leido  && this.inmuebles21.foto2.name != null){

                        let formData2 = new FormData();
                        formData2.append("miArchivoRentasVentas", this.inmuebles21.foto2);
                        axios.post( 'https://www.rentas-ventas.com/subeArchivo.php',
                            formData2,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'                   
                                }
                            }
                            ).then(function(){
                                alert('SUBIDA foto 2!!');
                            })
                            .catch(function(){
                                alert('FALLO subir foto 2 !!');
                            });    
                    } 
                                   
                }         


            }
    }
</script>


// WEBPACK FOOTER //
// src/Productos-editar.vue